export default __webpack_public_path__ + "static/media/simon2.38cfb214.png";